module.exports = __webpack_public_path__ + "static/media/fishing.3098f4cb.svg";